import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n';
import PageHero from '../components/PageHero';
import HighlightPhrase from '../components/HighlightPhrase';
import { SectionWrap, SectionHeader, Bullets, Prose } from '../components/SectionPrimitives';
import { VIDAT_IMG } from '../lib/images';

const IMG = VIDAT_IMG.estanque2;

const NumberedList = ({ items, testId }) => (
  <ol className="space-y-5 mt-2 list-none pl-0" data-testid={testId}>
    {items.map((item, i) => (
      <li key={i} className="grid grid-cols-[auto_1fr] gap-5 items-start border-b border-stone-200/70 pb-5">
        <span className="text-cyan-vidat font-mono text-xs pt-1.5">{String(i + 1).padStart(2, '0')}</span>
        <span className="text-stone-700 font-light leading-relaxed">{item}</span>
      </li>
    ))}
  </ol>
);

const Adiposidad = () => {
  const { content } = useI18n();
  const a = content.adiposity;
  const buttons = content.buttons;
  return (
    <main data-testid="adiposity-page">
      <PageHero eyebrow={a.eyebrow} title={a.title} lead={a.lead} image={IMG} testId="adiposity-hero" />

      <SectionWrap bg="ivory" testId="adiposity-forwhom">
        <SectionHeader title={a.forWhomTitle} />
        <Prose paragraphs={[a.forWhomP1, a.forWhomP2]} />
      </SectionWrap>

      <SectionWrap testId="adiposity-problem">
        <SectionHeader title={a.problemTitle} />
        <Prose paragraphs={[a.problemP1, a.problemP2]} />
      </SectionWrap>

      <SectionWrap bg="ivory" testId="adiposity-includes">
        <SectionHeader title={a.includesTitle} />
        <p className="text-stone-700 font-light max-w-3xl mb-8">{a.includesIntro}</p>
        <NumberedList items={a.includesList} testId="adiposity-includes-list" />
      </SectionWrap>

      <SectionWrap testId="adiposity-obtain">
        <SectionHeader title={a.obtainTitle} />
        <Bullets items={a.obtainList} />
        <div className="mt-12">
          <Link to="/programar-visita" className="btn-primary" data-testid="adiposity-cta-join">
            {buttons.joinFirstAssessments}
          </Link>
        </div>
      </SectionWrap>

      <HighlightPhrase eyebrow={a.closingTitle} dark testId="adiposity-highlight">
        {a.closingP1}
      </HighlightPhrase>

      <SectionWrap bg="ivory" testId="adiposity-closing">
        <Prose paragraphs={[a.closingP2]} />
      </SectionWrap>

    </main>
  );
};

export default Adiposidad;
